import { render, staticRenderFns } from "./queue.vue?vue&type=template&id=65287b29"
import script from "./queue.vue?vue&type=script&lang=js"
export * from "./queue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports